<template>
    <MdiIcon class="text-blue-800 bg-blue-100 rounded-md p-1 cursor-pointer border-blue-200 border m-2" icono="mdiTooth" @click="openModal('form-odontogramas-' + comp.name, {
      onlyOne: false, isClosable: false, component: OdontogramaModal, props: { ciadId, technologias, odontograma, comp, isEdit }
    })" />
</template>
<script setup lang="ts">
import { useModal } from '@/modules/Core/composables/useModal'
import MdiIcon from '@/modules/Core/components/general/MdiIcon.vue'
import OdontogramaModal from '@/modules/Asistencial/components/Consultation/Odontology/OdontogramaModal.vue'
import type { ICitaTechnologiasSalud } from '@/modules/Asistencial/interfaces'
import type { IFormComponent } from '@/modules/Administracion/interfaces'
import { useOdontograma } from "@/modules/Asistencial/composables/useOdontograma";
import { onMounted } from 'vue'
import { odontologicaService } from '@/services'
const { openModal } = useModal()
const props = defineProps<{
  ciadId: number
  technologias: ICitaTechnologiasSalud[]
  odontograma: string
  comp: IFormComponent
  isEdit: boolean
}>()
onMounted(async () => {
  const { setValidateOdontograma } = useOdontograma('historia')
  const { data } = await  odontologicaService.existsOdontologicas(props.technologias[0].cittId as number)
  setValidateOdontograma(props.odontograma, false)
  data.body.forEach(e => {
    if(e.coodNombre == props.odontograma) {
      setValidateOdontograma(props.odontograma, true)
    }
  })
})
</script>